interface PasswordMatchIndicatorProps {
  confirmPassword: string
  passwordsMatch: boolean | null
  className?: string
}

export function PasswordMatchIndicator({
  confirmPassword,
  passwordsMatch,
  className = ''
}: PasswordMatchIndicatorProps) {
  if (!confirmPassword || passwordsMatch === null) return null

  return (
    <div className={`mt-2 flex items-center gap-2 ${className}`}>
      {passwordsMatch ? (
        <>
          <svg
            className="w-4 h-4 text-green-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <span className="text-xs text-green-600 font-hebrew">הסיסמאות זהות</span>
        </>
      ) : (
        <>
          <svg
            className="w-4 h-4 text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
          <span className="text-xs text-red-600 font-hebrew">הסיסמאות אינן תואמות</span>
        </>
      )}
    </div>
  )
}
